import { render, staticRenderFns } from "./rungirl.vue?vue&type=template&id=21b599c8&scoped=true"
import script from "./rungirl.vue?vue&type=script&lang=js"
export * from "./rungirl.vue?vue&type=script&lang=js"
import style0 from "./rungirl.vue?vue&type=style&index=0&id=21b599c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b599c8",
  null
  
)

export default component.exports